import { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { getGalleryInner } from "../Service/Api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
import LazyLoad from 'react-lazyload';
function Gallery() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [monthOptions, setMonthOptions] = useState(["All"]);
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const Year = `${currentYear}`;
    setSelectedYear(Year);
    console.log("get current Year", Year);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const galleryData1 = await getGalleryInner();
      const galleryData = galleryData1.filter(item => item.category === 'PhotoGallery');
      setData(galleryData);

      const yearsSet = new Set();
      const monthsSet = new Set();

      galleryData.forEach(item => {
        if (item.date) {
          const date = new Date(item.date);
          yearsSet.add(date.getFullYear());
          monthsSet.add(date.getMonth());
        }
      });

      const uniqueYearRanges = Array.from(yearsSet).sort((a, b) => b - a);
      setYearRanges(uniqueYearRanges);

      const monthOptions = Array.from(monthsSet).sort((a, b) => a - b).map(month => monthNames[month]);
      setMonthOptions(["All", ...monthOptions]);
    };

    fetchData();
  }, []);

  useEffect(() => {
    let filteredData = data;

    if (selectedYear !== "All") {
      filteredData = filteredData.filter(item => {
        const itemDate = item.date?.trim();
        if (itemDate) {
          const date = new Date(itemDate);
          const year = date.getFullYear();
          const month = date.getMonth();
          return year === parseInt(selectedYear) && (selectedMonth === "All" || monthNames[month] === selectedMonth);
        }
        return false;
      });
    } else if (selectedMonth !== "All") {
      filteredData = filteredData.filter(item => {
        const itemDate = item.date?.trim();
        if (itemDate) {
          const month = new Date(itemDate).getMonth();
          return monthNames[month] === selectedMonth;
        }
        return false;
      });
    }

    if (searchQuery) {
      filteredData = filteredData.filter(item => item.title.toLowerCase().includes(searchQuery.toLowerCase()));
    }

    // Sort the filtered data by date in descending order
    filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));

    setFilteredData(filteredData);
  }, [selectedYear, selectedMonth, searchQuery, data]);

  const handleModal = id => {
    navigate(`/SubGallery?id=${id}`);
  };

  const emptyArray = [
    {
      description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.",
      attachments: ["director.jpg"]
    }
  ];
  function formatDate(originalDate) {
    const date = new Date(originalDate);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options).replace(/ /g, ' ');
  }
  return (
    <>
      <Header />
      {/* Inner Slider */}
      <section class="inr-header">
        <div class="container">
          <div class="inr-header-content">
            <h1 class="title">Gallery</h1>
            <ul class="breadcrumb">
              <li><NavLink to="/">Home</NavLink></li>
              <li> Gallery</li>
            </ul>
          </div>
        </div>
      </section>
      {/*  Inner Body */}
      <section className="innerBody">
        <div className="container  them-container">
          <div className="row">
            <div className="col-12">
              <h1>Gallery</h1>
            </div>
          </div>


          <div class="row">
            <div class="col-lg-12">
              <div class="searchbox1">
                <div class="dynamicdiv">
                  <div>Total Categories:<span class="categoryNo">{filterData.length}</span></div>
                  <div>Select Year
                    <select id="ddyears"
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                      className="yearSelection">
                      <option value="All">All</option>
                      {yearRanges.map((yr) => (
                        <option key={yr} value={yr}>{yr}</option>
                      ))}
                    </select>

                  </div>
                  <div>Select Month
                    <select id="monthli"
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      className="monthSelect">
                      {monthOptions.map((month, index) => (
                        <option key={index} value={month}>{month}</option>
                      ))}
                    </select>

                  </div>
                  <input type="search" id="myInput" class="textvalue" name="name" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} placeholder="Search Here.." />
                </div>
              </div>
            </div>
          </div>
          <div className='clr10'></div>
          <div class="row">
            <div class="col-12">
              <div id="showFour" class="mydivi years year2023 showYear">
                {filterData.length > 0 ? (
                  filterData.map((item, index) => (
                    <div class="galleryCount" key={index}>
                      <div class="photocontainer">
                        <div class="content">
                          <div class="photo-details">
                            <div class="photo-img">
                              <LazyLoad>  <img src={`https://webapi.entab.info/api/image/${item?.attachments[0]}`} class="img-fluid" alt="smnsbokaro" /></LazyLoad>
                              <div class="photo-desc">
                                <p>{item.title}</p>
                              </div>
                            </div>
                            <div class="photo-date">
                              <p>{formatDate(item.date)}</p>
                              <div class="photono">
                                <p>No Of Photos: {item?.attachments.length}</p>
                              </div>
                              <a onClick={() => navigate(`/SubGallery?id=${item._id}`)}><i class="bi bi-arrow-right"></i></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  ))
                ) : (
                  emptyArray.map((data, index) => (
                    <div key={index} class="galleryCount" >
                      <div class="photocontainer">
                        <div class="content">
                          <div class="photo-details">
                            <div class="photo-img">
                              <LazyLoad>
                                <img src="https://webapi.entab.info/api/image/SMNSB/public/images/gal-1.jpg" class="img-fluid" alt="smnsbokaro" /></LazyLoad>
                              <div class="photo-desc">
                                <p>Photo Title</p>
                              </div>
                            </div>
                            <div class="photo-date">
                              <p> DD.MM.YY</p>
                              <div class="photono">
                                <p>No Of Photos(0)</p>
                              </div>
                              <Link to={''}><i class="bi bi-arrow-right"></i></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

        </div>
      </section>
      <div className="clr100"></div>
      {/* Footer */}
      <Footer />
    </>
  )
}

export default Gallery